import { provideZoneChangeDetection } from '@angular/core';
// this seems to be a bug in lint parser. It thinks we are importing the whole library and throws 'Static imports of lazy-loaded libraries are forbidden' error.
// But we're not importing the whole library, just the definittion of the base PageNotFoundComponent, which is a standalone index file.

import { bootstrapApplication } from '@angular/platform-browser';

import { loadDevConfigOverride } from '@safarilaw-webapp/shared/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

const bootstrap = async (): Promise<void> => {
  // Dev only: pre-apply the (gitignored) config override before bootstrap so the base config is
  // lane-correct before Angular eagerly instantiates services that snapshot their API root
  // (e.g. CoManage). No-op in production/nonprod builds, where the override files are absent.
  if (!environment.production && !environment.nonprod) {
    await loadDevConfigOverride();
  }
  await bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] });
};

bootstrap().catch(err => {
  throw err;
});
